import { render, staticRenderFns } from "./BaskoBoxQuestions.vue?vue&type=template&id=1b2db95e&"
import script from "./BaskoBoxQuestions.vue?vue&type=script&lang=js&"
export * from "./BaskoBoxQuestions.vue?vue&type=script&lang=js&"
import style0 from "./BaskoBoxQuestions.vue?vue&type=style&index=0&id=1b2db95e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports